"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDateField = fixDateField;
exports.fixDateTimeField = fixDateTimeField;
exports.fixStringField = fixStringField;
exports.fixDateFormat = fixDateFormat;
const capitalize_1 = require("../methods/capitalize");
/**
 * naprawia wartośc w polu date
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key nazwa pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixDateField(parent, key) {
    let value = parent[key];
    let changed = false;
    if (value && value.length > 10) {
        value = value.substring(0, 10);
        changed = true;
    }
    if (changed) {
        parent[key] = value;
    }
    return changed;
}
/**
 * naprawia wartośc w polu date-time
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key klucz pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixDateTimeField(parent, key) {
    let value = parent[key];
    let changed = false;
    if (value) {
        if (value.indexOf('T') === 10) {
            value = value.replace('T', ' ');
            changed = true;
        }
        if (value.length < 19) {
            if (value.length >= 10) {
                value = value.substring(0, 10) + ' 00:00:00';
                changed = true;
            }
        }
    }
    if (changed) {
        parent[key] = value;
    }
    return changed;
}
/**
 * naprawia wartośc w polu string
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key klucz pola
 * @param {string} format format pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixStringField(parent, key, format) {
    const value = parent[key];
    if (value) {
        let nvalue = value;
        switch (format) {
            case 'uppercase':
                nvalue = value.toLocaleUpperCase();
                break;
            case 'lowercase':
                nvalue = value.toLocaleLowerCase();
                break;
            case 'capitalize':
                nvalue = (0, capitalize_1.capitalize)(value);
                break;
        }
        if (value !== nvalue) {
            parent[key] = nvalue;
            return true;
        }
    }
    return false;
}
/**
 * Naprawia formaty danych typu date i date-time
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data dane
 * @param {*} [Vue] konstruktor Vue
 * @returns {number} ile pól naprawino
 */
function fixDateFormat(schema, data) {
    let result = 0;
    if (schema.type === 'object') {
        const props = schema.properties;
        for (const key in schema.properties) {
            const pschema = props[key];
            switch (pschema.type) {
                case 'object':
                case 'array':
                    fixDateFormat(pschema, data[key]);
                    break;
                case 'string':
                    switch (pschema.format) {
                        case 'date-time':
                            result += fixDateTimeField(data, key) ? 1 : 0;
                            break;
                        case 'date':
                            result += fixDateField(data, key) ? 1 : 0;
                            break;
                        case 'uppercase':
                        case 'lowercase':
                        case 'capitalize':
                            result += fixStringField(data, key, pschema.format) ? 1 : 0;
                            break;
                    }
                    break;
            }
        }
    }
    else if (schema.type === 'array') {
        const pschema = schema.items;
        for (let i = 0; i < data.length; i++) {
            switch (pschema.type) {
                case 'object':
                case 'array':
                    result += fixDateFormat(pschema, data[i]);
                    break;
                case 'string':
                    switch (pschema.format) {
                        case 'date-time':
                            result += fixDateTimeField(data, i) ? 1 : 0;
                            break;
                        case 'date':
                            result += fixDateField(data, i) ? 1 : 0;
                            break;
                        case 'uppercase':
                        case 'lowercase':
                        case 'capitalize':
                            result += fixStringField(data, i, pschema.format) ? 1 : 0;
                            break;
                    }
                    break;
            }
        }
    }
    return result;
}
exports.default = fixDateFormat;
//# sourceMappingURL=fixDateFormat.js.map